import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ModalSto } from 'components/sto';

class ContactModal extends Component {
    render() {
        return (
            <ModalSto
                isCTA={false}
                modalType="contactUs"
                okText="general.ok"
                onOk={this.props.onOk}
                visible={this.props.visible}
            >
                <div className="contact-us-wrapper">
                    <h2 id="contact-title">
                        <FormattedMessage id="popup.contactus.contact.title" />
                    </h2>
                    <p id="contact-customer-service">
                        <FormattedMessage id="popup.contactus.contact.customerservice" />
                    </p>
                    <p>
                        <FormattedMessage id="popup.contactus.contact.bestbuy" />
                    </p>
                    <a
                        href={
                            'tel:' +
                            this.props.intl.formatMessage({
                                id: 'popup.contactus.contact.phonenumber.bestbuy',
                            })
                        }
                        id="page-contactUs-button-bestbuyPhoneNumber"
                    >
                        <FormattedMessage id="popup.contactus.contact.phonenumber.bestbuy" />
                    </a>
                    <p>
                        <FormattedMessage id="popup.contactus.contact" />
                    </p>
                    <a
                        href={
                            'tel:' +
                            this.props.intl.formatMessage({
                                id: 'popup.contactus.contact.phonenumber',
                            })
                        }
                        id="page-contactUs-button-otherPhoneNumber"
                    >
                        <FormattedMessage id="popup.contactus.contact.phonenumber" />
                    </a>
                    <p className="contact-us-popup-support">
                        <FormattedMessage id="popup.contactus.contact.businesshours" />
                    </p>
                </div>
            </ModalSto>
        );
    }
}

export default injectIntl(ContactModal);
